import React from "react";

// reactstrap components
import {
    Table,
} from "reactstrap";

class StockReports extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                    <tr>
                        <th scope="col">Tanggal</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Warehouse asal</th>
                        <th scope="col">Warehouse tujuan</th>
                        <th scope="col" />
                    </tr>
                </thead>
                <tbody>
                    {this.props.items.map((item) => (
                        <tr>
                            <th scope="row">{new Date(item.create_at).toLocaleDateString() + ' ' + new Date(item.create_at).toLocaleTimeString()}</th>
                            <td>{item.quantity}</td>
                            <td>{item.warehouse_source_name}</td>
                            <td>{item.warehouse_destination_name}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        )
    };
}

export default StockReports;
